import { api } from '../utils/api';

export async function getToken(bodyRequest: { username: string; password: string }) {
  const resp = api.post<{ token: string }>('/api/v1/users/jwt-token/', bodyRequest);
  return resp;
}
